<app-auth-navbar></app-auth-navbar>
<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mx-auto" style="margin-top: 180px;">
                <h3 class="signin_heading custom-heading text-center">A password reset email has been sent</h3>
                <br>
                <div class="text-center">
                    <p class="signin__text">If an account <br>exists on N2Xpress, you will receive a password reset email there shortly.</p>
                </div>
        </div>
    </div>
</div>